module.exports = __webpack_public_path__ + "img/dianchiReport5.63c9951d.png";